import { useState } from 'react';
import PropTypes from 'prop-types';
// import EmailStarToggle from './email-star-toggle';
import { Checkbox, Avatar } from '@evertrue/et-components';

const EmailCardSelectors = ({ email = {}, handleBulkSelect = () => {}, threadCount = 0 }) => {
  const { id, status, email_recipients = [] } = email;

  const from = email_recipients.find((recipient) => recipient.recipient_type === 'FROM');
  const name = from?.contact?.name;
  const avatar = from?.contact?.avatar;

  const [isSelected, setIsSelected] = useState(false);

  const handleCheckboxChange = () => {
    setIsSelected(!isSelected);
    handleBulkSelect(id);
  };
  const isSentOrReplied = status === 'SENT' || status === 'REPLIED';

  return (
    <div className="email-card-selectors" style={{ height: '100%' }}>
      {!isSentOrReplied && (
        <Checkbox
          className="email-card--checkbox-small"
          checked={isSelected}
          label="select"
          onChange={handleCheckboxChange}
        />
      )}
      {/* <EmailStarToggle email={email} /> */}
      {isSentOrReplied && (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'flex-start', height: '100%' }}>
          <Avatar className="new-contact-card--avatar fs-exclude-data" name={name} url={avatar} width={30} />
          {threadCount > 1 && <span className="thread-indicator" />}
        </div>
      )}
    </div>
  );
};

EmailCardSelectors.propTypes = {
  email: PropTypes.object,
  handleBulkSelect: PropTypes.func,
  threadCount: PropTypes.number,
};

export default EmailCardSelectors;
